import Header from "./components/Header";
import Intro from "./components/Intro";
import About from "./components/About";
import Work from "./components/Work";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-[#FAF7F2] min-h-screen">
      <Header />
      <main>
        <Intro />
        <About />
        <Work />
        <Education />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
